import __request__ from "routing/request";
export function getConditions() {
  return __request__("GET", "/streams/destinations/filters/builder/conditions", null, {}, {
    "Accept": ["application/json"]
  });
}
export function simulateRule() {
  return __request__("POST", "/streams/destinations/filters/builder/simulate", null, {}, {
    "Accept": ["application/json"]
  });
}
export function validateRule(rule) {
  return __request__("POST", "/streams/destinations/filters/builder/validate", rule, {}, {
    "Accept": ["application/json"]
  });
}
